module.exports = "/_next/static/images/ActivateUnify@2x-459d810f0e9dacd53e2127ed167bb63c.png";